import React from 'react';

import styles from './style/Unauthorized.module.css'

const Unauthorized: React.FC = () => {
  return (
    <div className={styles.container}>
      <h1>Sorry, your account has not yet been validated by an Admin.</h1>
    </div>
  );
};
export default Unauthorized;
